var ChatbotConversationUserActionType = /* @__PURE__ */ function(ChatbotConversationUserActionType2) {
  ChatbotConversationUserActionType2["SUMMARIZE"] = "summarize";
  ChatbotConversationUserActionType2["LIST_POINTS"] = "listPoints";
  ChatbotConversationUserActionType2["EXPLAIN_LIKE_IM_FIVE"] = "explainLikeImFive";
  ChatbotConversationUserActionType2["CLEANUP"] = "cleanup";
  ChatbotConversationUserActionType2["TWEET"] = "tweet";
  ChatbotConversationUserActionType2["TODO_LIST"] = "todoList";
  ChatbotConversationUserActionType2["EMAIL"] = "email";
  return ChatbotConversationUserActionType2;
}({});
var ChatbotConversationUserActionSubType = /* @__PURE__ */ function(ChatbotConversationUserActionSubType2) {
  ChatbotConversationUserActionSubType2["TEXT"] = "text";
  ChatbotConversationUserActionSubType2["SELECTION"] = "selection";
  return ChatbotConversationUserActionSubType2;
}({});
const MascotStateMachine = "Main";
const MascotDarkModeStateMachine = "DarkMode";
var MascotState = /* @__PURE__ */ function(MascotState2) {
  MascotState2["BROKEN"] = "broken";
  MascotState2["CONFUSED"] = "confused";
  MascotState2["TIRED"] = "tired";
  MascotState2["SLEEP"] = "sleep";
  MascotState2["GLASS"] = "glass";
  MascotState2["DARK_MODE"] = "darkMode";
  MascotState2["LIGHT_MODE"] = "lightMode";
  return MascotState2;
}({});
var MascotStateActions = /* @__PURE__ */ function(MascotStateActions2) {
  MascotStateActions2["AMAZED"] = "amazed";
  MascotStateActions2["BLINK2"] = "blink2";
  MascotStateActions2["BLINK1"] = "blink1";
  MascotStateActions2["WINK"] = "wink";
  MascotStateActions2["DREAMING"] = "dreaming";
  MascotStateActions2["LOVE"] = "love";
  MascotStateActions2["HAPPY"] = "happy";
  MascotStateActions2["IDLE"] = "idle";
  return MascotStateActions2;
}({});
var AssistantContextType = /* @__PURE__ */ function(AssistantContextType2) {
  AssistantContextType2["None"] = "none";
  AssistantContextType2["Ancestor"] = "ancestor";
  AssistantContextType2["Resource"] = "resource";
  AssistantContextType2["Selection"] = "selection";
  return AssistantContextType2;
}({});
var AssistantContextSubType = /* @__PURE__ */ function(AssistantContextSubType2) {
  AssistantContextSubType2["Everything"] = "everything";
  AssistantContextSubType2["Space"] = "space";
  AssistantContextSubType2["Folder"] = "folder";
  AssistantContextSubType2["File"] = "file";
  AssistantContextSubType2["Connection"] = "connection";
  AssistantContextSubType2["Selection"] = "selection";
  return AssistantContextSubType2;
}({});

export { AssistantContextSubType, AssistantContextType, ChatbotConversationUserActionSubType, ChatbotConversationUserActionType, MascotDarkModeStateMachine, MascotState, MascotStateActions, MascotStateMachine };
//# sourceMappingURL=types.js.map
